<app-dialog-header
  [header]="'library.user_card.action.reset_password.header' | translate"
  iconClass="icon-refresh-pass-icon"
>
</app-dialog-header>
<app-dialog-content [formGroup]="form">
  <div class="p-grid">
    <div class="p-col-12">
      <app-form-control-label
        [control]="form.get('emailLanguage')"
        for="email-language"
      >
        {{ 'language_dropdown.label' | translate }}:
      </app-form-control-label>
      <app-tooltip-icon
        [appTooltip]="'configure_smtp' | translate"
        [hidden]="smtpStatus?.active"
      >
      </app-tooltip-icon>
      <app-dropdown
        id="email-language"
        [options]="languageOptions"
        [placeholder]="'language_dropdown.placeholder' | translate"
        data-qa="language-dropdown"
        formControlName="emailLanguage"
      ></app-dropdown>
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <button
    (click)="close()"
    data-qa="reset-password-cancel-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.cancel.label' | translate }}
  </button>
  <button
    (click)="submit(form)"
    data-qa="reset-password-confirm-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'button.confirm.label' | translate }}
  </button>
</div>
